import { PropsWithChildren } from "react";

import { Box, media, xcss } from "@atlaskit/primitives";
import { JiraBackground } from "@atlassian/product-wireframes";

import { Modal } from "@/components/signup/layouts/modal";
import { LayoutVersion } from "@/components/signup/layouts/product-overlay-template";

type JiraOverlayProps = PropsWithChildren<{
    isMobileResponsive?: boolean;
}>;

export const JiraOverlay = ({
    children,
    isMobileResponsive = false
}: JiraOverlayProps) => (
    <JiraBackground>
        <Modal size="lg" showBrandFooter={false} version={LayoutVersion.V2}>
            <Box xcss={isMobileResponsive ? responsiveWrapper : wrapper}>
                {children}
            </Box>
        </Modal>
    </JiraBackground>
);

const wrapper = xcss({
    width: "100%",
    maxWidth: "1140px",
    height: "640px",
    overflow: "hidden"
});

const responsiveWrapper = xcss({
    width: "100%",
    maxWidth: "1140px",
    height: "auto",
    overflow: "hidden",
    [media.above.md]: {
        height: "640px"
    }
});
